import { ScadaPlusWindTurbineMarker } from "./ScadaPlusWindTurbineMarker";
export default ScadaPlusWindTurbineMarker;
